module.exports = __webpack_public_path__ + "static/media/lincoln-thumbs.044f3a90.svg";